import React, { useEffect, useState } from 'react';

import { Box, Button, Grid } from '@mui/material';

import { ModalBox } from 'src/components/ModalContent/Modal';

import { AssignToggle } from '../AssignToggle';
import { OptionTypes } from '../FormikComponents/FieldInput';

interface AssignPartnersModalProps {
    open: boolean;
    onClose: () => void;
    onAssign: (options: OptionTypes[]) => void;
    onUnassign: (options: OptionTypes[]) => void;
    assignedInitial: OptionTypes[];
    unassignedInitial: OptionTypes[];
}

const AssignPartnersModal: React.FC<AssignPartnersModalProps> = ({
    open,
    onClose,
    onAssign,
    onUnassign,
    assignedInitial,
    unassignedInitial,
}) => {
    const [assigned, setAssigned] = useState<OptionTypes[]>(assignedInitial);
    const [unassigned, setUnassigned] = useState<OptionTypes[]>(unassignedInitial);

    useEffect(() => {
        if (open) {
            setAssigned([...assignedInitial]);
            setUnassigned([...unassignedInitial]);
        }
    }, [open, assignedInitial, unassignedInitial]);

    const updateSelection = async (selectedItems, fromList, toList, setToList, setFromList) => {
        const updatedFromList = [...fromList];
        const updatedToList = [...toList];

        for (const item of selectedItems) {
            const primaryIndex = updatedFromList.findIndex(
                (u) => u.value === item.value && u.type === item.type
            );
            if (primaryIndex !== -1) {
                const primaryItem = updatedFromList.splice(primaryIndex, 1)[0];
                updatedToList.push(primaryItem);

                if (primaryItem.linkedId && primaryItem.linkedId.length) {
                    for (const linkedId of primaryItem.linkedId) {
                        const linkedIndex = updatedFromList.findIndex(
                            (u) => u.businessId === linkedId && u.type !== primaryItem.type
                        );
                        if (linkedIndex !== -1) {
                            const linkedItem = updatedFromList.splice(linkedIndex, 1)[0];
                            updatedToList.push(linkedItem);
                        }
                    }
                }
            }
        }

        setToList([...new Set(updatedToList)]);
        setFromList([...new Set(updatedFromList)]);
    };

    const handleAssign = async (selected) => {
        await updateSelection(selected, unassigned, assigned, setAssigned, setUnassigned);
    };

    const handleUnassign = async (selected) => {
        await updateSelection(selected, assigned, unassigned, setUnassigned, setAssigned);
    };

    const handleSave = () => {
        onAssign(assigned);
        onUnassign(unassigned);
        onClose();
    };

    return (
        <ModalBox open={open} handleCloseModal={onClose} title="Assign Partners" widthSize="720px">
            <Box sx={{ p: 3 }}>
                <AssignToggle
                    assigned={assigned}
                    unassigned={unassigned}
                    onAssign={handleAssign}
                    onUnassign={handleUnassign}
                    assignedTitled="Assigned Partners"
                    unassignedTitled="Unassigned Partners"
                />
                <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                    <Grid item>
                        <Button variant="outlined-black" onClick={onClose}>
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button variant="main" onClick={handleSave}>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </ModalBox>
    );
};

export default AssignPartnersModal;
